import React, {useState} from 'react';
import TextBox from '../components/textbox'
import Button from '../components/button'
import '../styling/containerStyles.css'
import Label from '../components/label'
import codeValid from '../assets/images/codeValid.png'
import codeInvalid from '../assets/images/codeInvalid.png'
import codeUsed from '../assets/images/codeUsed.png'
import SimpleCaptcha from '../simpleCaptcha'

interface VerifyNumberProps{
    scan: boolean;
    msgPh?:string;
    handleToUpdateVerified:Function;
    codeScanStatusCode: any;
}

export const VerifyNumber: React.FC<VerifyNumberProps> = (props: VerifyNumberProps) =>{

    const{
        handleToUpdateVerified, scan, msgPh, codeScanStatusCode
    } = props;

    const [phoneNo, setPhoneNo] = useState('')
    const [message, setMessage] = useState('')
    const handleToUpdateContent = (name:string, arg:string) => {
        if(name === 'phoneNo'){
            setPhoneNo(arg)
        }
        
    }

    const handleToUpdateNumber = (arg:string) => {
        if(scan === true){ 
            var re = /^[0-9]{10}$/;
            if(re.test(phoneNo) )
                handleToUpdateVerified(phoneNo)
            else{
                setMessage('Please enter a valid number')
                setPhoneNo('')
            }
        }
    }
        return (
            <div className='home'>
                {scan &&
                <div className='verifyNumberPage'>
                    {localStorage.getItem("isDealerVerified") === "yes" ?  null : 
                    <img src={codeValid} alt='code valid' className='codeValidImg'/>
                    }
                    <div className='verifyNumberImg'> </div>
                    <div className='verifyNumber'>
                        
                    {localStorage.getItem("isDealerVerified") === "yes" ? 
                    <Label content='Verify Painter Token' /> :
                        <Label content='Verify Number' />}

                        <TextBox className='textBox'
                                label={''} 
                                state={'phoneNo'}
                                placeholder={'Enter registered contact number'} 
                                handleToUpdate={handleToUpdateContent}
                        />

                        <div className='message'>{msgPh}</div>
                        <br></br>
                        <div className='message'>{message}</div>

                        {phoneNo === localStorage.getItem('phone_number') ?
                        null
                        :
                        <Button label= {'Enter registered contact number'} 
                                name={'VERIFY NUMBER'} 
                                visible={true}
                                handleToUpdate={handleToUpdateNumber}  />
                        }

                    </div>
                    {phoneNo === localStorage.getItem('phone_number') ?
                    <SimpleCaptcha phoneNo={phoneNo} handleToUpdateNumber={handleToUpdateNumber} />
                    :
                    null}
                </div>   
                 }
                 {   
                    !scan &&
                    (codeScanStatusCode === 901 ?
                     <div className='verifyNumberPage'>
                     <img src={codeUsed} alt='code valid' className='codeValidImg'/> 
                     </div> :
                     codeScanStatusCode !== 901 &&
                     <div className='verifyNumberPage'>
                     <img src={codeInvalid} alt='code valid' className='codeValidImg'/> 
                     </div>)
                }
            </div>             
        )
    }

export default VerifyNumber